import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { PhoneBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { formatPhone } from '@apply/ui';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface PhoneProps {
    propertyGuid: string;
    isReview?: boolean;
}

export const Phone: React.FC<PhoneProps> = ({ propertyGuid, isReview = false }) => {
    const label = 'Phone';
    const [phone, set_phone] = useBudgetConstructionField<string>(
        propertyGuid,
        (b) => b.values?.['Electrical (Largest Subcontractor or Supplier)']?.['Phone'] ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Electrical (Largest Subcontractor or Supplier)': { ...b.values?.['Electrical (Largest Subcontractor or Supplier)'], 'Phone': v } } })
    );

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={`Contact ${label}`}
                    value={formatPhone(phone)}
                />
            ) : (
                <PhoneBox
                    id='phone'
                    value={phone}
                    onChange={(value) => set_phone(value)}
                    label={label}
                    width='100%'
                />
            )}
        </>
    );
};
